import React from 'react';
import { motion } from 'framer-motion';

export default function Footer() {
  const footerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <motion.footer
      className="bg-gradient-to-r from-pink-200 via-yellow-100 to-pink-100 text-center py-8 text-gray-800"
      variants={footerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.5 }} // Animation always enabled
    >
      <div className="max-w-6xl mx-auto px-4">
        <p className="mb-2">
          &copy; {new Date().getFullYear()} All rights reserved. A3 Creative Hub. <br/> AFFORDABLE. ARTISTIC. ACCESSIBLE.
        </p>
      </div>
    </motion.footer>
  );
}